import JournalTabs from '@chegg-wt/core/components/SourceSearchResults/JournalTabs'
import React from 'react'
import SearchResultsContent from './SearchResultsContent'
import { SearchResultsProps } from './types'
import * as Styled from './styled'

export const SearchResults: React.FunctionComponent<SearchResultsProps> = ({
  afterFirstSource,
  afterSecondSource,
  isOverflow,
  sources,
  loading,
  error,
  citationStyle,
  searchText,
  sourceType,
  journalType,
  invalidSearch,
  onSelectSource,
  onChangeJournalType,
  onChangeSourceType,
  onManualCiteClick,
}) => {
  return (
    <Styled.Container isOverflow={isOverflow}>
      {sourceType?.id === 'journal' &&
        !invalidSearch &&
        (loading || sources || error) && (
          <JournalTabs active={journalType} onChange={onChangeJournalType} />
        )}
      <SearchResultsContent
        afterFirstSource={afterFirstSource}
        afterSecondSource={afterSecondSource}
        sources={sources}
        loading={loading}
        error={error}
        citationStyle={citationStyle}
        searchText={searchText}
        sourceType={sourceType}
        journalType={journalType}
        onSelectSource={onSelectSource}
        invalidSearch={invalidSearch}
        onChangeSourceType={onChangeSourceType}
        onManualCiteClick={onManualCiteClick}
        onChangeJournalType={onChangeJournalType}
      />
    </Styled.Container>
  )
}

export default SearchResults
